// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@ces/XDL/Icons/Close";
import { buttonTransparent } from "@ces/XDL/PreStyle/button";
import { xBaseTheme } from "@ces/XDL/types";
import color, { getSystemColor } from "@ces/XDL/Utilities/color";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        typographyProps: {
            size: 11,
            weight: "bold",
            color: getSystemColor("common.ui1"),
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 13px;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        color: "primary",
        iconProps: {
            size: 6,
            src: Close,
            css: css`
                padding-top: 7px;
            `,
        },
        mergeCss: true,
        css: css`
            min-height: 26px;
            border-radius: 14px;
            align-items: flex-start;
            max-width: unset;
            gap: 8px;
            padding: 6px 8px;
            margin: 0 8px 8px 0;
            button {
                margin: 0;
                ${buttonTransparent}
                &:hover {
                    ${IconWrapper} {
                        color: ${color("common.ui8", 0.66)};
                    }
                }
            }
        `,
    },
} as xBaseTheme["tag"];
